package com.eladfinish.bible.contest.platform.audio

enum class SoundEffect {
    CORRECT,
    WRONG,
    TIME_UP,
    SUCCESS,
}
